module.exports = __webpack_public_path__ + "img/Restaurant1.93f5cc0c.png";